<template>
	<Row>
		<div class="label mr-2">
			{{ item.title }}
		</div>
		<component :is="indicator" v-if="isUpgradeRequired" :billingFeatureId="item.billingFeatureId" />
	</Row>
</template>

<script>
export default {
	name: 'GroupPermittedUsesItem',
	props: {
		item: { type: Object },
		isUpgradeRequired: { type: Boolean, default: false },
		indicator: { type: Object, default: null },
	},
};
</script>

<style scoped lang="scss">
.label {
	font-size: 14px;
	color: var(--primary-font-color);
}
</style>
